import React from "react";

const StatCard = ({
  title,
  count,
  icon,
  iconBg = "#F8F4E8",
  iconColor = "#D4A017",
}) => {
  return (
    <div className="bg-white border  border-gray-200 rounded-lg p-5 shadow-sm flex items-center gap-3 hover:scale-105 transition-all duration-300 ease-in-out">
      <div className="w-[3.2rem] h-[3.2rem] rounded-lg bg-[#FFFAEB] flex items-center justify-center text-[#DEA915] border-[1px] border-orange-200 p-3">
        {icon}
      </div>

      <div>
        <p className="text-[.8rem] font-semibold text-gray-500">{title}</p>
        <p className="text-[1.8rem] font-bold leading-9 text-[#0F172A]">
          {count ?? "0"}
        </p>
      </div>
    </div>
  );
};

export default StatCard;
